export default [
  {
    name: 'newPassword',
    label: 'users.newPassword',
    type: 'text',
    required: true,
  },
  {
    name: 'repeatNewPassword',
    label: 'users.repeatNewPassword',
    type: 'text',
    required: true,
  },
];
